import PropTypes from "prop-types"
import { urlHelper } from "../util.mjs"
import { createImageSet } from "../utils/createImageSet"
import LinkWrapper from "./LinkWrapper"

const LinkResolver = ({ link, children, className, circleIcon, ...other }) => {
  switch (link.system ? link.system.type : ``) {
    case "link__external_":
      return (
        <a href={link.elements.link_url.value} className={className} {...other}>
          {children
            ? children
            : link.elements.title
              ? link.elements.title.value
              : `No Title`}
        </a>
      )

    case "link_content_item":
      const [contentItem] = link.elements.link_to___.value
      const linkTitle = link.elements.label.value
        ? link.elements.label.value
        : contentItem
          ? contentItem.elements.title.value
          : ``
      const icon = link.elements.icon__icon.value
      const imageSet =
        link.elements.image && link.elements.image.value.length
          ? createImageSet(link.elements.image.value[0])
          : null
      const image = imageSet ? imageSet["lg"] : null
      return (
        <LinkWrapper
          to={urlHelper(contentItem)}
          className={`${className}`}
          {...other}
        >
          {icon ? (
            circleIcon ? (
              <span
                className={`rounded-full bg-gray-200 text-gray-700 text-2xl w-10 h-10 inline-flex items-center justify-center mr-2`}
              >
                <i className={`${icon}`} aria-hidden></i>
              </span>
            ) : (
              <i className={`${icon} text-2xl mr-2`} aria-hidden></i>
            )
          ) : null}
          {image ? <img src={`${image.url}?w=65`} alt={``} /> : null}
          {children ? children : linkTitle ? linkTitle : `No Title`}
        </LinkWrapper>
      )

    default:
      return (
        <LinkWrapper to={urlHelper(link)} className={className} {...other}>
          {children
            ? children
            : link.elements.title
              ? link.elements.title.value
              : `No Title`}
        </LinkWrapper>
      )
  }
}

LinkResolver.propTypes = {
  link: PropTypes.object,
}

export default LinkResolver
